import type { FaireProductEntity } from "../../entity_types/product";

export const p_7heutsgu: FaireProductEntity = {
  token: "p_7heutsgu",
  type: "product",
  name: "Adventure Anniversary Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6a2cd49f9b856e5da601fb682897867eeeac4b81e9d1a4ee529c505d208dacfc.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b3d50420ed3e0f256a156ed16798cd5e388d08f62797634b415bf097d384f05.png",
    "https://cdn.faire.com/fastly/c0facc5093988f45e18aba976974a708ca3aa9558cf5846110245e219a26e2b6.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:51.534Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
